// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { clientLogger } from '@seedplanner/logger';
import fetch from 'cross-fetch';
import { ClientError } from './errors';
import { labels } from './labels';

export const sendToServer = ({
  route,
  body,
  title,
}: {
  readonly route: string;
  readonly body: string;
  readonly title: string;
}) => {
  const commonLogInfo = {
    [labels.HTTP_METHOD]: 'POST',
    [labels.HTTP_PATH]: route,
    title,
  };

  const headers = {
    'Content-Type': 'application/json',
  };

  return fetch(route, {
    method: 'POST',
    headers,
    body,
    credentials: 'same-origin',
  }).then(
    async (response) => {
      if (response.ok) {
        return;
      }
      const error = await ClientError.getFromResponse(response);
      const logInfo = {
        [labels.HTTP_STATUS_CODE]: response.status,
        error: error.message,
        ...commonLogInfo,
      };
      clientLogger.info(logInfo);

      throw error;
    },
    (error) => {
      const logInfo = {
        [labels.HTTP_STATUS_CODE]: -1,
        error: error.message,
        ...commonLogInfo,
      };
      clientLogger.error(logInfo);

      throw ClientError.getFromNetworkError(error);
    },
  );
};
